import { EventEmitter } from '@apia/util';

export class ApiaUtilMouse extends EventEmitter<{
  updatePosition: { x: number; y: number };
}> {
  x = 0;
  y = 0;

  get position() {
    return { x: this.x, y: this.y };
  }

  constructor() {
    super();

    document.addEventListener('mousemove', (ev) => {
      this.x = ev.clientX;
      this.y = ev.clientY;

      this.emit('updatePosition', { x: this.x, y: this.y });
    });
  }
}
